// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2zs13","list":"PatternAutocomplete_list__3kmIV"};